
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`warehouse-groups/${this.$route.query.id}`).then(res => {
        this.form = { ...res.data, name: res.data.locales.ja_JP }
      })
    },
    save() {
      this.$http
        .put(`warehouse-groups/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$http
        .delete(`/warehouse-groups/${this.$route.query.id}`)
        .then(() => {
          this.$router.go(-1)
        })
    }
  }
}
</script>
